import React from 'react'
import { MarkerSvgProps } from './MarkerSvgProps'

export const CongestionSvg = ({ style }: MarkerSvgProps) => {
  return (
    <svg
      width="32"
      height="40"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g opacity="0.35" filter="url(#filter0_f_8284_162963)">
        <path
          d="M24 34.5C24 35.8807 20.4183 37 16 37C11.5817 37 8 35.8807 8 34.5C8 33.1193 11.5817 32 16 32C20.4183 32 24 33.1193 24 34.5Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2C3.34315 2 2 3.34315 2 5V26C2 27.6569 3.34315 29 5 29H11.914C12.2369 29 12.54 29.156 12.7277 29.4188L15.1863 32.8608C15.5851 33.4191 16.4149 33.4191 16.8137 32.8608L19.2723 29.4188C19.46 29.156 19.7631 29 20.086 29H27C28.6569 29 30 27.6569 30 26V5C30 3.34315 28.6569 2 27 2H5Z"
        fill="#FF9418"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.599609 5.0001C0.599609 2.57004 2.56956 0.600098 4.99961 0.600098H26.9996C29.4297 0.600098 31.3996 2.57004 31.3996 5.0001V26.0001C31.3996 28.4302 29.4297 30.4001 26.9996 30.4001H20.2915L17.9526 33.6746C16.9954 35.0146 15.0038 35.0146 14.0466 33.6746L11.7077 30.4001H4.99961C2.56956 30.4001 0.599609 28.4302 0.599609 26.0001V5.0001ZM1.99961 5.0001C1.99961 3.34324 3.34276 2.0001 4.99961 2.0001H26.9996C28.6565 2.0001 29.9996 3.34324 29.9996 5.0001V26.0001C29.9996 27.657 28.6565 29.0001 26.9996 29.0001H20.0857C19.7627 29.0001 19.4596 29.1561 19.2719 29.4189L16.8133 32.8609C16.4145 33.4192 15.5847 33.4192 15.1859 32.8609L12.7273 29.4189C12.5396 29.1561 12.2365 29.0001 11.9136 29.0001H4.99961C3.34276 29.0001 1.99961 27.657 1.99961 26.0001V5.0001Z"
        fill="white"
      />
      <path
        d="M14 11.5C14 13.433 12.433 15 10.5 15C8.567 15 7 13.433 7 11.5C7 9.567 8.567 8 10.5 8C12.433 8 14 9.567 14 11.5Z"
        fill="white"
      />
      <path
        d="M25 11.5C25 13.433 23.433 15 21.5 15C19.567 15 18 13.433 18 11.5C18 9.567 19.567 8 21.5 8C23.433 8 25 9.567 25 11.5Z"
        fill="white"
      />
      <path
        d="M7 17.7857C7 16.2472 8.24721 15 9.78571 15H11.2143C12.7528 15 14 16.2472 14 17.7857V23H7V17.7857Z"
        fill="white"
      />
      <path
        d="M18 17.7857C18 16.2472 19.2472 15 20.7857 15H22.2143C23.7528 15 25 16.2472 25 17.7857V23H18V17.7857Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_8284_162963"
          x="5"
          y="29"
          width="22"
          height="11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_8284_162963"
          />
        </filter>
      </defs>
    </svg>
  )
}
